import { MapPin, Phone, EnvelopeSimple } from "@phosphor-icons/react";
import { Link } from "react-router-dom";

export default function Footer() {
    return (
        <footer className="border-t border-ink/10 mt-24 bg-bone" data-testid="footer">
            <div className="mx-auto max-w-7xl px-6 py-14 grid md:grid-cols-4 gap-10">
                {/* Brand */}
                <div className="md:col-span-2">
                    <div className="font-serif text-2xl text-ink">Wibpro Academy</div>
                    <div className="text-xs tracking-[0.25em] text-ink/50 uppercase mt-1">EST. 2010 · Hyderabad</div>
                    <p className="text-sm text-ink/60 mt-4 max-w-md leading-relaxed">
                        A modern institute for competitive-exam preparation and overseas education.
                        Built for the serious student.
                    </p>
                </div>

                {/* Contact */}
                <div>
                    <div className="text-xs uppercase tracking-[0.28em] text-gold mb-3">Visit us</div>
                    <ul className="space-y-3 text-sm text-ink/80">
                        <li className="flex gap-2" data-testid="footer-address">
                            <MapPin size={14} weight="fill" className="text-ink/60 mt-1 shrink-0"/>
                            <span>2nd floor, Safa Arcade,<br/>Opposite pillar 15, Mehdipatnam,<br/>Hyderabad, Telangana, India</span>
                        </li>
                        <li className="flex items-center gap-2" data-testid="footer-phone">
                            <Phone size={14} weight="fill" className="text-ink/60 shrink-0"/>
                            <a href="tel:+919100560075" className="hover:text-ink underline underline-offset-4 decoration-gold decoration-2">+91 91005 60075</a>
                        </li>
                        <li className="flex items-center gap-2">
                            <EnvelopeSimple size={14} weight="fill" className="text-ink/60 shrink-0"/>
                            <a href="mailto:hello@wibpro.com" className="hover:text-ink">hello@wibpro.com</a>
                        </li>
                    </ul>
                </div>

                {/* Links */}
                <div>
                    <div className="text-xs uppercase tracking-[0.28em] text-gold mb-3">Explore</div>
                    <ul className="space-y-2 text-sm text-ink/80">
                        <li><Link to="/courses" className="hover:text-ink" data-testid="footer-link-courses">All courses</Link></li>
                        <li><Link to="/tuitions" className="hover:text-ink" data-testid="footer-link-tuitions">School tuitions</Link></li>
                        <li><Link to="/resources" className="hover:text-ink" data-testid="footer-link-resources">Past papers</Link></li>
                        <li><Link to="/study-abroad" className="hover:text-ink" data-testid="footer-link-study-abroad">Study abroad</Link></li>
                        <li><Link to="/pricing" className="hover:text-ink">Pricing</Link></li>
                        <li><Link to="/register" className="hover:text-ink">Enrol</Link></li>
                    </ul>
                </div>
            </div>

            <div className="border-t border-ink/10">
                <div className="mx-auto max-w-7xl px-6 py-4 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2 text-xs text-ink/50">
                    <div>© {new Date().getFullYear()} Wibpro Academy · Hyderabad, India</div>
                    <div>Made with rigour · for students who study hard.</div>
                </div>
            </div>
        </footer>
    );
}
